export default Form => ({ formRef, ...otherProps }) => (
  <Form ref={formRef} {...otherProps} />
);
